import {combineReducers} from "redux";
import questionnaire from "./QuestionnaireReducer"
import patients from "./PatientsReducer"
import currentStep from "./CurrentStepReducer"
import progenyInfo from "./ProgenyInfoReducer"
import messageBox from "./MessageBoxReducer"
import {i18nReducer} from 'react-redux-i18n';

export default combineReducers({
    currentStep,
    questionnaire,
    patients,
    progenyInfo,
    messageBox,
    i18n: i18nReducer
});